import i18n from 'i18next'
import LanguageDetector from './languageDetector'
import { reactI18nextModule } from 'react-i18next'
import commonEN from '../locale/en/common'
import commonFR from '../locale/fr/common'

const setTranslation = (resources: { en: any; fr: any }) => {
  i18n.use(reactI18nextModule).init({
    resources: {
      en: {
        ...commonEN,
        ...resources.en
      },
      fr: {
        ...commonFR,
        ...resources.fr
      }
    },
    lng: LanguageDetector(),
    fallbackLng: 'en',
    debug: true,
    ns: ['app', 'common'],
    defaultNS: 'app',
    interpolation: {
      escapeValue: false // not needed for react!!
    },

    react: {
      wait: true
    }
  })
}

export default setTranslation
